import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { HttpService, type IHttpService } from '../services/http/http.service';

export function useQrIconName(uuid: string | null) {
  const http = useInjection<IHttpService>(HttpService);
  const { data: iconName = null, isLoading } = useQuery({
    queryKey: ['qr-icon-name', uuid],
    queryFn: () => http.get<{ iconName: string }>(`qr-icon/${uuid}`).then((r) => r.iconName),
    enabled: uuid !== null,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });

  return { iconName, isLoading };
}
